import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  root: {
    margin: '24px',
    fontFamily: 'Circular Std, sans-serif',
    backgroundColor: '#EFF0F2',
    borderRadius: '4px',
    padding: '16px',
  },
  titleContainer: {
    marginBottom: '16px',
  },
  title: {
    fontSize: '22px',
    fontWeight: 700,
    color: '#000000DE',
  },
  description: {
    fontSize: '14px',
    color: '#00000099',
  },
  teamContainer: {
    display: 'flex',
    gap: '56px',
  },
  team: {
    display: 'flex',
    gap: '16px',
    fontWeight: 600,
    fontSize: '16px',
  },
}));
